import clsx from "classnames";
import classes from "./styles.module.scss";
import OfficeCard2 from "@/components/OfficeCard2";
import HeaderTitle from "@/components/HeaderTitle";

export default function OfficeListing({ offices, className }) {

  return (
    <div className={clsx(className, classes.listing_cont)}>
      <div className={classes.listing}>
        {offices?.map((office, index) => (
          <div className={classes.item} key={index}>
            <OfficeCard2 office={{office}} />
          </div>
        ))}
      </div>
    </div>
  );
}

OfficeListing.defaultProps = {
  className: "",
};
